// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-box {
  background-color: var(--attentionBoxBackgroundColour) !important;
  box-shadow: 2px 2px 5px 0px rgba(50, 50, 50, 0.05);
  border-radius: 5px;
  padding: 35px;
  cursor: pointer;
  min-height: 140px;
}

.attention-box {
  padding: 35px;
  min-height: 140px;
}

.attention-border {
  outline: 2px solid var(--errorColour);
  outline-offset: -2px;
}

.error-colour {
  color: var(--errorColour);
}

.widget-inner-box {
  max-height: 120px;
  overflow-y: auto;
  overflow-x: hidden;
}

.stats-wrapper {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  padding-bottom: 10px;
}

.widget .header.padding-top {
  padding-top: 0.3rem !important;
}

.stats-box .top-line {
  min-height: 64px;
}
.stats-box .stats-inner {
  padding: 5px 15px 15px 15px;
  height: 170px;
  color: var(--textColour);
  text-align: left;
  cursor: pointer;
}
.stats-box .stats-inner .fa, .stats-box .stats-inner .far {
  font-size: 30px;
}
.stats-box .stats-inner .number {
  font-size: 2.5rem;
  text-align: right;
  font-weight: 500;
  color: var(--linkColour);
}
.stats-box .stats-inner .title {
  font-size: 18px;
  letter-spacing: -0.5px;
  font-weight: 600;
}
.stats-box .stats-inner .subtitle {
  color: var(--subtitleColour);
  font-size: 14px;
  margin: 3px 0 7px 0;
  font-weight: 400;
}

.welcome-text {
  font-size: 32px;
  font-weight: 600;
  letter-spacing: -1px;
}

.sub-text {
  font-size: 1rem;
  font-weight: 400;
  color: rgb(50, 50, 50);
}

.advert-scroller-box {
  position: relative;
  width: 100%;
  aspect-ratio: var(--aspectRatio);
  background-color: #fff;
}
.advert-scroller-box .scroller-image {
  object-fit: contain;
  height: 100%;
  width: 100%;
}
.advert-scroller-box .headline {
  color: var(--linkColour);
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  line-height: 1rem;
  overflow-x: hidden;
  overflow-y: hidden;
}
.advert-scroller-box .summary-lines {
  white-space: nowrap;
  width: 100%;
  font-size: 0.7rem;
  font-weight: 400;
  color: #23313D;
  line-height: 0.75rem;
  overflow-x: hidden;
  overflow-y: hidden;
}

.source {
  font-size: 0.75rem;
  color: #888;
  line-height: 1.1rem;
  display: inline-block;
  color: #CD6927;
}

.thumbnail-image {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  height: 100%;
  width: 100%;
  border-radius: 10px;
}

.news-item {
  background-color: #fff;
}
.news-item:nth-child(even) {
  background-color: var(--tableAltColour);
}

.news {
  display: grid;
  grid-column-gap: 15px;
  grid-template-columns: 74px 1fr;
  padding: 2px 10px 2px 0;
}

.news-image {
  width: 74px;
  display: inline-block;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  flex-basis: 74px;
  height: 49px;
  max-width: 74px;
  flex-grow: 1;
  border: 1px solid #dfdfdf;
  border-radius: 4px;
}

.news-title {
  display: flex;
  align-items: center;
  flex-grow: 1;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
}
.news-title a, .news-title a:visited {
  color: var(--subtitleColour) !important;
}
.news-title a:hover {
  color: var(--linkColour) !important;
}

.scroller-footer {
  height: 45px;
  position: absolute;
  bottom: 0px;
  overflow-x: hidden;
  background-color: rgba(232, 243, 255, 0.8);
  width: 100%;
  padding: 0 5px;
  display: flex;
  align-items: center;
  border-radius: 0 0 10px 10px;
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/main/dashboard/dashboard.component.scss"],"names":[],"mappings":"AAAA;EACE,gEAAA;EACA,kDAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;AACF;;AAEA;EACE,qCAAA;EACA,oBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EAEE,iBAAA;EACA,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,cAAA;EACA,2DAAA;EACA,oBAAA;AAAF;;AAGA;EACE,8BAAA;AAAF;;AAKE;EAEE,gBAAA;AAHJ;AAOE;EAEE,2BAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;AANJ;AAQI;EAEE,eAAA;AAPN;AAWI;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;AATN;AAYI;EACE,eAAA;EACA,sBAAA;EACA,gBAAA;AAVN;AAaI;EACE,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAXN;;AAgBA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AAbF;;AAgBA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,WAAA;EACA,gCAAA;EACA,sBAAA;AAbF;AAeE;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AAbJ;AAgBE;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;AAfJ;;AAoBA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;AAjBF;;AAoBA;EACE,4BAAA;EACA,kCAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAjBF;;AAoBA;EAEE,sBAAA;AAlBF;AAoBE;EACE,uCAAA;AAlBJ;;AAsBA;EACE,aAAA;EACA,qBAAA;EACA,+BAAA;EACA,uBAAA;AAnBF;;AAsBA;EAEE,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,kCAAA;EACA,4BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AApBF;;AAuBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AApBF;AAsBE;EACE,uCAAA;AApBJ;AAuBE;EACE,mCAAA;AArBJ;;AA2BA;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,4BAAA;AAxBF","sourcesContent":[".header-box {\n  background-color: var(--attentionBoxBackgroundColour) !important;\n  box-shadow: 2px 2px 5px 0px rgba(50, 50, 50, 0.05);\n  border-radius: 5px;\n  padding: 35px;\n  cursor: pointer;\n  min-height: 140px;\n}\n\n.attention-box {\n  padding: 35px;\n  min-height: 140px;\n}\n\n.attention-border {\n  outline: 2px solid var(--errorColour);\n  outline-offset: -2px;\n}\n\n.error-colour {\n  color: var(--errorColour);\n}\n\n.widget-inner-box {\n\n  max-height: 120px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.stats-wrapper {\n  display: grid;\n  grid-gap: 10px;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  padding-bottom: 10px;\n}\n\n.widget .header.padding-top {\n  padding-top: 0.3rem !important\n}\n\n.stats-box {\n\n  .top-line {\n\n    min-height: 64px;\n\n  }\n\n  .stats-inner {\n\n    padding: 5px 15px 15px 15px;\n    height: 170px;\n    color: var(--textColour);\n    text-align: left;\n    cursor: pointer;\n\n    .fa, .far {\n\n      font-size: 30px;\n\n    }\n\n    .number {\n      font-size: 2.5rem;\n      text-align: right;\n      font-weight: 500;\n      color: var(--linkColour);\n    }\n\n    .title {\n      font-size: 18px;\n      letter-spacing: -0.5px;\n      font-weight: 600;\n    }\n\n    .subtitle {\n      color: var(--subtitleColour);\n      font-size: 14px;\n      margin: 3px 0 7px 0;\n      font-weight: 400;\n    }\n  }\n}\n\n.welcome-text {\n  font-size: 32px;\n  font-weight: 600;\n  letter-spacing: -1px;\n}\n\n.sub-text {\n  font-size: 1rem;\n  font-weight: 400;\n  color: rgb(50, 50, 50);\n}\n\n.advert-scroller-box {\n  position: relative;\n  width: 100%;\n  aspect-ratio: var(--aspectRatio);\n  background-color: #fff;\n\n  .scroller-image {\n    object-fit: contain;\n    height: 100%;\n    width: 100%;\n  }\n\n  .headline {\n    color: var(--linkColour);\n    font-size: 0.75rem;\n    font-weight: 600;\n    white-space: nowrap;\n    line-height: 1rem;\n    overflow-x: hidden;\n    overflow-y: hidden;\n  }\n\n  .summary-lines {\n    white-space: nowrap;\n    width: 100%;\n    font-size: 0.7rem;\n    font-weight: 400;\n    color: #23313D;\n    line-height: 0.75rem;\n    overflow-x: hidden;\n    overflow-y: hidden;\n  }\n}\n\n\n.source {\n  font-size: 0.75rem;\n  color: #888;\n  line-height: 1.1rem;\n  display: inline-block;\n  color: #CD6927;\n}\n\n.thumbnail-image {\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  height: 100%;\n  width: 100%;\n  border-radius: 10px;\n}\n\n.news-item {\n\n  background-color: #fff;\n\n  &:nth-child(even) {\n    background-color: var(--tableAltColour);\n  }\n}\n\n.news {\n  display: grid;\n  grid-column-gap: 15px;\n  grid-template-columns: 74px 1fr;\n  padding: 2px 10px 2px 0;\n}\n\n.news-image {\n\n  width: 74px;\n  display: inline-block;\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  flex-basis: 74px;\n  height: 49px;\n  max-width: 74px;\n  flex-grow: 1;\n  border: 1px solid #dfdfdf;\n  border-radius: 4px;\n}\n\n.news-title {\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 1rem;\n\n  a, a:visited {\n    color: var(--subtitleColour) !important;\n  }\n\n  a:hover {\n    color: var(--linkColour) !important;\n\n  }\n}\n\n\n.scroller-footer {\n  height: 45px;\n  position: absolute;\n  bottom: 0px;\n  overflow-x: hidden;\n  background-color: rgba(232, 243, 255, 0.8);\n  width: 100%;\n  padding: 0 5px;\n  display: flex;\n  align-items: center;\n  border-radius: 0 0 10px 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
